// Initialize Faro telemetry before Module Federation runs.
import('./telemetry')
	.catch((error) => {
		console.error('Faro telemetry failed to load', error);
	})
	.then(() => import('./bootstrap'));
// We need to bootstrap the application for the 'Plugins Framework' to work.
